import React, { useEffect, useRef } from "react";
import { Box, Flex, Icon, useToast, Text } from "@chakra-ui/react";
import {
	ERROR_MSG,
	INFO_MSG,
	LOGIN_FAIL,
	LOGIN_SUCCESS,
	REGISTER_FAIL,
	REGISTER_SUCCESS,
	SUCCESS_MSG,
	CUSTOM_GREEN_TOAST,
} from "../utils/store/store";
import { useDispatch } from "react-redux";
import { setMessage } from "../utils/store/store";

export const ToastNotification = (toastMsg: any) => {
	const toast = useToast();
	const dispatch = useDispatch();

	const timerRef = useRef<number | null>(null);

	useEffect(() => {
		const toastCase = toastMsg?.toastMsg?.message?.case;
		const title = toastMsg?.toastMsg?.message?.title || "";
		const message = toastMsg?.toastMsg?.message?.data || "";
		const icon = toastMsg?.toastMsg?.message?.icon;

		if (!toastCase || !message) return;

		// Clear any previous timer
		if (timerRef.current) window.clearTimeout(timerRef.current);

		// Use a stable id so it doesn't stack / re-open
		const toastId = "global-toast";

		const triggerToast = (status: any, customIcon?: any) => {
			// Close existing toast with same id only
			if (toast.isActive(toastId)) toast.close(toastId);

			if (status === "CUSTOM_GREEN_TOAST") {
				toast({
					id: toastId,
					position: "top-right",
					duration: 3000,
					isClosable: true,
					render: () => (
						<Flex
							bg="#ECFFF2"
							borderRadius=".375rem"
							border="1px solid #359051"
							boxShadow="md"
							alignItems="flex-start"
							p=".75rem 2rem .75rem 1.25rem"
							fontSize=".875rem"
							m="2.5rem 1rem"
						>
							{customIcon && (
								<Icon as={customIcon} boxSize="1rem" mt="1" color="#359051" />
							)}
							<Box ml=".75rem">
								{!!title && (
									<Text fontWeight="500" color="#359051" lineHeight="1.25rem">
										{title}
									</Text>
								)}
								<Text color="black">{message}</Text>
							</Box>
						</Flex>
					),
				});
			} else {
				toast({
					id: toastId,
					title: title.length > 0 ? title : message,
					description: title.length > 0 ? message : undefined,
					status,
					isClosable: true,
					position: "top-right",
					variant: "left-accent",
					duration: 3000,
				});
			}

			// ✅ Clear redux message after toast duration so it unmounts
			timerRef.current = window.setTimeout(() => {
				dispatch(setMessage(""));
			}, 3000);
		};

		switch (toastCase) {
			case LOGIN_FAIL:
			case REGISTER_FAIL:
			case ERROR_MSG:
				triggerToast("error");
				break;

			case LOGIN_SUCCESS:
			case REGISTER_SUCCESS:
			case SUCCESS_MSG:
				triggerToast("success");
				break;

			case INFO_MSG:
				triggerToast("info");
				break;

			case CUSTOM_GREEN_TOAST:
				triggerToast("CUSTOM_GREEN_TOAST", icon);
				break;

			default:
				break;
		}

		return () => {
			if (timerRef.current) window.clearTimeout(timerRef.current);
		};
	}, [
		toastMsg?.toastMsg?.message?.case,
		toastMsg?.toastMsg?.message?.data,
		toastMsg?.toastMsg?.message?.title,
		toastMsg?.toastMsg?.message?.icon,
		toast,
		dispatch,
	]);

	return <Box />;
};
